import React from 'react';
import './SimpleTemplateEditor.css';
import {
  useTemplateEditor,
  TemplateList,
  TemplateCreateForm,
  TemplateInfoPanel,
  EditorModal,
} from './template-editor';

const SimpleTemplateEditor = () => {
  const editor = useTemplateEditor();

  return (
    <div className="template-editor-container">
      {/* Nagłówek */}
      <div className="template-editor-header">
        <div>
          <h2 className="template-editor-title">Kreator Szablonów Faktur</h2>
          <p className="template-editor-subtitle">Twórz i zarządzaj szablonami dokumentów sprzedażowych</p>
        </div>
        <button
          className="btn btn-success"
          onClick={() => editor.setShowCreateForm(true)}
          disabled={editor.showCreateForm}
        >
          <span>➕</span> Nowy szablon
        </button>
      </div>

      {/* Komunikaty */}
      {editor.loading && (
        <div className="loading-overlay">
          <div className="spinner"></div>
          <span style={{ marginLeft: '15px', fontSize: '16px' }}>Ładowanie szablonów...</span>
        </div>
      )}

      {editor.error && (
        <div className="alert alert-error">
          <span>❌</span> {editor.error}
          <button className="alert-close" onClick={() => editor.setError(null)}>×</button>
        </div>
      )}

      {editor.success && (
        <div className="alert alert-success">
          <span>✅</span> {editor.success}
          <button className="alert-close" onClick={() => editor.setSuccess(null)}>×</button>
        </div>
      )}

      {/* Formularz tworzenia nowego szablonu */}
      {editor.showCreateForm && (
        <TemplateCreateForm
          newTemplateName={editor.newTemplateName}
          setNewTemplateName={editor.setNewTemplateName}
          newTemplateType={editor.newTemplateType}
          setNewTemplateType={editor.setNewTemplateType}
          creating={editor.creating}
          createTemplate={editor.createTemplate}
          closeCreateForm={editor.closeCreateForm}
        />
      )}

      {/* Lista szablonów */}
      <TemplateList
        templates={editor.templates}
        loading={editor.loading}
        editingTemplateName={editor.editingTemplateName}
        setEditingTemplateName={editor.setEditingTemplateName}
        renameTemplate={editor.renameTemplate}
        editTemplate={editor.editTemplate}
        previewTemplateHandler={editor.previewTemplateHandler}
        previewLoading={editor.previewLoading}
        duplicateTemplate={editor.duplicateTemplate}
        duplicatingTemplate={editor.duplicatingTemplate}
        toggleTemplateAnchor={editor.toggleTemplateAnchor}
        deleteTemplate={editor.deleteTemplate}
      />

      {/* Status rozwoju */}
      <TemplateInfoPanel />

      {/* Modal edytora szablonu */}
      {editor.showEditor && editor.editingTemplate && (
        <EditorModal
          editingTemplate={editor.editingTemplate}
          editingFields={editor.editingFields}
          saving={editor.saving}
          previewLoading={editor.previewLoading}
          expandedFields={editor.expandedFields}
          selectedFieldId={editor.selectedFieldId}
          showVariables={editor.showVariables}
          saveTemplate={editor.saveTemplate}
          closeEditor={editor.closeEditor}
          previewTemplateHandler={editor.previewTemplateHandler}
          updateGlobalSetting={editor.updateGlobalSetting}
          resetAllFontsToGlobal={editor.resetAllFontsToGlobal}
          addField={editor.addField}
          updateField={editor.updateField}
          removeField={editor.removeField}
          addContentLine={editor.addContentLine}
          updateContentLine={editor.updateContentLine}
          removeContentLine={editor.removeContentLine}
          toggleLineBold={editor.toggleLineBold}
          toggleVariablesPanel={editor.toggleVariablesPanel}
          insertVariable={editor.insertVariable}
          insertVariableNewLine={editor.insertVariableNewLine}
          toggleFieldExpansion={editor.toggleFieldExpansion}
          selectField={editor.selectField}
          expandAllFields={editor.expandAllFields}
          collapseAllFields={editor.collapseAllFields}
          moveFieldUp={editor.moveFieldUp}
          moveFieldDown={editor.moveFieldDown}
          moveFieldToPosition={editor.moveFieldToPosition}
          moveColumnUp={editor.moveColumnUp}
          moveColumnDown={editor.moveColumnDown}
        />
      )}
    </div>
  );
};

export default SimpleTemplateEditor;
